import React from "react";
import img1 from "./imgs/RSmartPlus+.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/RSmartPlus+E.jpg";


export function RSmartPlus2() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img1}/>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                </>
            }
        </>
    )
}